import { render, staticRenderFns } from "./ServiceSearchResult.vue?vue&type=template&id=5bc31c96&scoped=true"
import script from "./ServiceSearchResult.vue?vue&type=script&lang=js"
export * from "./ServiceSearchResult.vue?vue&type=script&lang=js"
import style0 from "./ServiceSearchResult.vue?vue&type=style&index=0&id=5bc31c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc31c96",
  null
  
)

export default component.exports